import { useEffect, useState } from "react";
import { subscribeSiteSettings } from "../data/firestore";
import { doctor as defaultDoctor, contact as defaultContact } from "../data/content";

/**
 * Live doctor/practice details, with the static content.js values as
 * the fallback for any field the admin hasn't set yet in Firestore.
 * Nothing on the site ever shows blank because a field is unconfigured.
 */
export default function useSiteSettings() {
  const [overrides, setOverrides] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = subscribeSiteSettings((data) => {
      setOverrides(data);
      setLoading(false);
    });
    return unsub;
  }, []);

  const doctor = {
    ...defaultDoctor,
    ...overrides,
    address: { ...defaultDoctor.address, ...overrides?.address },
    geo: { ...defaultDoctor.geo, ...overrides?.geo },
    profiles: { ...defaultDoctor.profiles, ...overrides?.profiles },
  };

  const contact = {
    ...defaultContact,
    hours: overrides?.hours?.length ? overrides.hours : defaultContact.hours,
    intro: overrides?.contactIntro || defaultContact.intro,
    note: overrides?.contactNote || defaultContact.note,
  };

  return { doctor, contact, loading, isOverridden: Boolean(overrides) };
}
